import React, { Component } from 'react';

export default class CVEntry extends Component
{
	render()
	{
		return (
			<div className="layout-cs-card">
				<div className="layout-cs-card-content">
					<h2>{this.props.title}</h2>
					{this.props.children}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/CVEntry.js